import { useIntl } from "react-intl";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export default function StudentLicenseStatusIcon({
  student,
  programName,
  isAplProgram,
}) {
  const intl = useIntl();

  if (!student.requiredLicenseIsMissing) {
    return null;
  }

  let icon;
  let titleId;

  if (student.hasValidAplLicense) {
    titleId = !student.activatedAccount
      ? "Student_HasAplButNeedProgramLicenseAndActivation"
      : "Student_HasAplButNeedProgramLicense";
    icon = (
      <InfoOutlinedIcon className="license-warning-icon license-info-icon" />
    );
  } else if (isAplProgram) {
    titleId = !student.activatedAccount
      ? "Student_NeedAplLicenseAndActivation"
      : "Student_NeedAplLicense";
    icon = <WarningAmberIcon className="text-warning license-warning-icon" />;
  } else {
    titleId = !student.activatedAccount
      ? "Student_NeedLicenseAndActivation"
      : "Student_NeedLicense";
    icon = <WarningAmberIcon className="text-warning license-warning-icon" />;
  }

  return (
    <span title={intl.formatMessage({ id: titleId }, { programName })}>
      {icon}
    </span>
  );
}
